function isArrayBuffer(object: unknown): object is ArrayBuffer {
    try {
        return object instanceof ArrayBuffer || object instanceof Buffer;
    } catch {
        /* Buffer|ArrayBuffer definitions missing (running in Browser?) */
        return false;
    }
}

function arrayBufferToString(buffer: ArrayBuffer): string {
    const result = new TextDecoder().decode(buffer);
    return result;
}

function stringToArrayBuffer(string_: string): ArrayBuffer {
    const byteArray = new TextEncoder().encode(string_);
    const buffer = byteArray.buffer;
    return buffer;
}

function bufferToArrayBuffer(buffer: Buffer): ArrayBuffer {
    const arrayBuffer = new ArrayBuffer(buffer.length);
    /* This looks like bufferView is completely redundant but this is the correct way to modify an ArrayBuffer
        https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer
    */
    const bufferView = new Uint8Array(arrayBuffer);
    for (const [index, element] of buffer.entries()) {
        bufferView[index] = element;
    }
    return arrayBuffer;
}

const arrayBufferToBuffer = (arrayBuffer: ArrayBuffer): Buffer => Buffer.from(arrayBuffer);

export default Object.freeze({
    arrayBufferToString,
    stringToArrayBuffer,
    bufferToArrayBuffer,
    arrayBufferToBuffer,
    isArrayBuffer,
});
